export const FETCH_VISITOR_REQUEST = 'FETCH_VISITOR_REQUEST';
export const FETCH_VISITOR_SUCCESS = 'FETCH_VISITOR_SUCCESS';
export const FETCH_VISITOR_FAILURE = 'FETCH_VISITOR_FAILURE';

export const ADD_VISITOR_REQUEST = 'ADD_VISITOR_REQUEST';
export const ADD_VISITOR_SUCCESS = 'ADD_VISITOR_SUCCESS';
export const ADD_VISITOR_FAILURE = 'ADD_VISITOR_FAILURE';

export const UPDATE_VISITOR_REQUEST = 'UPDATE_VISITOR_REQUEST';
export const UPDATE_VISITOR_SUCCESS = 'UPDATE_VISITOR_SUCCESS';
export const UPDATE_VISITOR_FAILURE = 'UPDATE_VISITOR_FAILURE';

export const DELETE_VISITOR_REQUEST = 'DELETE_VISITOR_REQUEST';
export const DELETE_VISITOR_SUCCESS = 'DELETE_VISITOR_SUCCESS';
export const DELETE_VISITOR_FAILURE = 'DELETE_VISITOR_FAILURE';